module.exports = __webpack_public_path__ + "assets/img/modal-no-backdrop-transparent@2x.png";